module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_FREE@3x.b0c08561.png";